module.exports = __webpack_public_path__ + "img/abrigos-y-gabardinas.baa0b906.jpg";